import ObjectOnMap from '../../../common/components/object_on_map/object_on_map';
import { Button, ButtonTheme } from '@cian/components';
import * as React from 'react';
import { render } from 'react-dom';

const styles = require('./map_with_toggle.css');

interface IMapWithToggleProps {
  opened?: boolean;
  coordinates: IYmapsCoord;
  mapNode: HTMLElement;
  ymapsUrlWithKey: string;
}

interface IMapWithToggleState {
  opened?: boolean;
}

export default class MapWithToggle extends React.Component<IMapWithToggleProps, IMapWithToggleState> {
  private map: ObjectOnMap;

  public constructor(props: IMapWithToggleProps) {
    super(props);

    this.state = {
      opened: props.opened || false,
    };
  }

  public componentDidMount() {
    this.props.mapNode.classList.add(styles['container']);
  }

  public componentDidUpdate() {
    this.props.mapNode.classList.toggle(styles['container-open'], this.state.opened);
  }

  public render() {
    const buttonStyle = [
      'cf-bsc-serp-li-action',
      'cf-bsc-serp-li-action_map-trigger',
    ];
    if (this.state.opened) {
      buttonStyle.push('cf-bsc-serp-li-action_visible');
    }
    return (
      <Button theme={ButtonTheme.BLUELIGHT_SOLID} onClick={() => this.toggle()} buttonStyle={buttonStyle}>
        {!this.state.opened ? 'Показать на карте' : 'Скрыть карту'}
      </Button>
    );
  }

  private toggle() {
    const newOpenedState = !this.state.opened;

    if (newOpenedState === true) {
      if (this.map) {
        this.map.center();
      } else {
        render(
          <ObjectOnMap
            height={300}
            zoom={14}
            latlng={this.props.coordinates}
            ref={map => this.map = map}
            ymapsUrlWithKey={this.props.ymapsUrlWithKey}
          />,
          this.props.mapNode
        );
      }
    }

    this.setState({
      opened: newOpenedState,
    });
  }
}



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/components/map_with_toggle/map_with_toggle.tsx